import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import { alpha, withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import React from 'react';
import Customicon from '../../Customicon';
import theme from '../../theme';

const styles = (t) => ({
	card: {
		boxShadow: 'none',
		border: '1px dotted',
		borderColor: t.palette.grey[300],
		padding: t.spacing(1) * 0.5,
		borderRadius: t.shape.borderRadius,
		width: '100%',
		maxWidth: 148,
		minWidth: 0,
		margin: 0,
		textAlign: 'center',
	},
	iconButton: {
		paddingTop: 2,
		paddingBottom: 2,
		paddingLeft: 4,
		paddingRight: 0,
		'&:hover': {
			background: 'transparent',
		},
		[t.breakpoints.down('sm')]: {
			padding: t.spacing(1),
		},
	},
	paper: {
		textAlign: 'center',
		color: t.palette.grey[800],
		background: 'transparent',
		borderRightWidth: '1px',
		borderStyle: 'solid',
		borderColor: t.palette.grey[400],
		fontSize: 14,
	},
	input: {
		display: 'none',
	},
	button: {
		width: 82,
		height: 34,
		fontFamily: 'NHaasGroteskDSPro-55Rg',
		transition: '200ms ease',
		'&:hover': {
			background: t.palette.primary.main,
			color: t.palette.primary.contrastText,
		},
		[t.breakpoints.down('sm')]: {
			minHeight: 40,
			minWidth: 44,
			height: 'auto',
			paddingTop: t.spacing(1),
			paddingBottom: t.spacing(1),
		},
	},
	buttonCompact: {
		[t.breakpoints.up('md')]: {
			height: 30,
			minHeight: 30,
			width: 76,
			padding: '4px 8px',
		},
	},
	textAction: {
		minWidth: 0,
		padding: '4px 6px',
		fontFamily: 'NHaasGroteskDSPro-55Rg',
		fontSize: '0.8rem',
		textTransform: 'none',
		lineHeight: 1.2,
		'&:hover': {
			backgroundColor: alpha(t.palette.primary.main, 0.08),
		},
	},
	textActionCompact: {
		[t.breakpoints.up('md')]: {
			fontSize: '0.75rem',
			padding: '2px 4px',
		},
	},
});
class WarrantyCell extends React.Component {
   

    EmptyWarrantyCell(props) {
        const {
			classes,
			isDistributor,
			compactWarranty,
			warrantyKind,
			productSummaryForA11y,
		} = props;
        const openDialog = this.props.onOpenProductLineDialog || this.props.handleProductLine;
        const kindLabel = warrantyKind === 'performance' ? 'performance' : 'component';
        const a11yName = productSummaryForA11y || 'product';
        const tooltipTitle = (
			'Opens product line assignment. Component and performance warranties are configured on the assigned product line.'
		);
        return isDistributor ? 'No Warranty Info Available' : (
			<Tooltip title={tooltipTitle} placement="top">
				<span>
					<Button
						size="small"
						color="primary"
						variant="text"
						type="button"
						className={classNames(
							classes.textAction,
							compactWarranty && classes.textActionCompact,
						)}
						onClick={() => openDialog && openDialog()}
						aria-label={`Set ${kindLabel} warranty via product line dialog for ${a11yName}`}
					>
						{compactWarranty ? 'Via line' : 'Set via product line'}
					</Button>
				</span>
			</Tooltip>
		);
    }
    HavingWarrantyNotLinkCell(props) {
        const { classes, isDistributor } = props;
        return <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.card}
            spacing={8}
        >
            <Grid item xs>
                <Paper square className={classes.paper} elevation={0}>{props.warrantyInYears}</Paper>                
            </Grid>
            {!isDistributor && <Grid item>
                <input
                    accept="file/*"
                    className={classes.input}
                    id="text-button-file"
                    type="file"
                />
                <label htmlFor="text-button-file">
                    <IconButton color="primary" aria-label="View" className={classes.iconButton} component="span">
                        <Customicon name="upload" width={13} fill="#0d4add" />
                    </IconButton>
                </label>
            </Grid>}
        </Grid>

     
    }

    HasCompleteWarranty(props) {
        const { classes} = props;
        return <Grid
            container
            direction="row"
            justify="space-between"
            alignItems="center"
            className={classes.card}

        >
            <Grid item xs={6}>
                <Paper square className={classes.paper} elevation={0}>{props.warrantyInYears}</Paper>
            </Grid>
            <Grid item xs={6}>           
                <IconButton color="primary" disableRipple href={props.warrantyLinks} target="_blank" download={props.warrantyLinks} aria-label="View" className={classes.iconButton} component="a">
                    <Customicon name="pdf" width={18} fill={theme.palette.common.red} />
                    </IconButton>
            </Grid>
        </Grid>
    
    }


    render() {
        const exists = this.props.iswarrantyExists;
        const warrantyInYears = this.props.warrantyInYears;
        if (!exists) {
            return this.EmptyWarrantyCell(this.props);
        }
        else if (warrantyInYears != null && warrantyInYears > 0 && this.props.warrantyLinks==null) {
            return this.HavingWarrantyNotLinkCell(this.props);
        }
        else {
            return this.HasCompleteWarranty(this.props);
        }
    }

}

export default withStyles(styles)(WarrantyCell);